import React from "react";

const PostmanIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
    >
      <path
        fill="#F36933"
        d="M18.855 6.049a.145.145 0 00-.053.159v-.001a.412.412 0 01-.054.45l.001-.001a.139.139 0 00-.03.087c0 .044.021.084.053.11a.143.143 0 00.084.03c.042 0 .08-.02.106-.05a.69.69 0 00.086-.752.138.138 0 00-.193-.032z"
      ></path>
      <path fill="#F36933" d="M19.049 6.082L19.047 6.078 19.048 6.081z"></path>
      <path
        fill="#F36933"
        d="M13.527.099C6.955-.744.942 3.9.099 10.473c-.843 6.572 3.8 12.584 10.373 13.428 6.573.843 12.588-3.801 13.429-10.374C24.745 6.955 20.102.943 13.527.099zm2.471 7.485a.851.851 0 00-.593.25l-4.453 4.453-.95-.95c4.389-4.376 5.181-4.418 5.996-3.753zm-4.863 4.861l4.44-4.44a.62.62 0 11.848.902l-.001.001-4.699 4.125-.588-.588zm.33.694l-1.1.238a.057.057 0 01-.013.001.06.06 0 01-.054-.033.06.06 0 01.01-.073l.645-.645.512.512zm-2.803-.459l1.172-1.172.879.878-1.979.426a.11.11 0 01-.019.002.074.074 0 01-.066-.041.071.071 0 01-.011-.039c0-.021.009-.041.024-.054zm-3.646 6.057a.074.074 0 01-.069-.075v-.008a.077.077 0 01.022-.046h.002l.946-.946 1.222 1.222-2.123-.147zm2.426-1.255a.227.227 0 00-.117.258v-.002l.203.865a.125.125 0 01-.211.117h-.003l-1.228-1.229 3.762-3.758 1.82-.393.874.874c-1.255 1.102-2.971 2.201-5.1 3.268zm5.278-3.428h-.002l-.839-.839 4.699-4.125a.985.985 0 00.117-.125l.002-.002c-.147 1.345-2.029 3.245-3.977 5.091zm4.942-5.928a1.81 1.81 0 01-1.285-.532h.001l-.003-.002a1.822 1.822 0 012.461-2.681l-.003-.002-1.61 1.613a.117.117 0 00-.035.084c0 .033.013.063.035.084l1.247 1.247a1.801 1.801 0 01-.808.189zm1.294-.532c-.081.08-.169.151-.265.214l-.006.004h-.001l-1.207-1.207 1.533-1.533c.661.72.637 1.832-.054 2.522z"
      ></path>
    </svg>
  );
};

export default PostmanIcon;
